export class EmployeeDetail {
    public ID: number;
    public HashCode: string;
    public Employee_HashCode: string;
    public SchoolID: number;
    public YearID: number;
    public QualificationID: number;
    public EmpTypeID: number;
    public EmpPositionID: number;
    public EmpName: string;
    public EmpAddress: string;
    public EmpMobile: string;
    public EmpEmail: string;
    public EmpAdditionalQualification: string;
    public EmpSalary: number;
    public PendingSalaryIncrementAmount: number;
    public PendingSalaryIncrementDescription: string = "";
    public DepreciationAmount: number;
    public DepreciationDescription: string = "";
}